export enum ProductTileSurface {
  SEARCH_PAGE = "SEARCH_PAGE",
  BRAND_PAGE = "BRAND_PAGE",
  SDUI = "SDUI",
  CART_PAGE = "CART_PAGE",
}
